import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const AGENCY_CONVERSATIONS_EVENT_NAMES = {
  TOGGLE_BANNERS: 'interagency_chat_banner_notifications_turned',
};

/** Reports an admin turning interagency chat notification banners on or off. */
export function trackToggleInteragencyBannersOnOff(
  irpVersion: string,
  bannersOn: boolean,
) {
  const toggleStatus = bannersOn ? 'On' : 'Off';
  gspx.trackEvent({
    name: AGENCY_CONVERSATIONS_EVENT_NAMES.TOGGLE_BANNERS,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Agency Conversations Notification Banners were turned ${toggleStatus}`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
}
